/**
 * How many gallery cells fit in a viewport (used by uniform folder gallery + tests).
 */
export function fitUniformGalleryGrid(
    width: number,
    height: number,
    cellW: number,
    cellH: number,
    gap: number,
): { cols: number; rows: number } {
    if (width <= 0 || height <= 0) {
        return { cols: 2, rows: 2 };
    }
    const cols = Math.max(1, Math.floor((width + gap) / (cellW + gap)));
    const rows = Math.max(1, Math.floor((height + gap) / (cellH + gap)));
    return { cols, rows };
}
